import React from 'react';
import '../../../styles/loading.css';

export const Loading: React.FC = () => {
    return (
        <div className="loading-container">
            <div className="loading-content">
                <div className="loading-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                </div>
                <h2 className="loading-title">Carregando sistema...</h2>
                <p className="loading-message">Aguarde enquanto configuramos tudo para você</p>
            </div>
        </div>
    );
};
